export type FxBreakpoint = "xs" | "sm" | "md" | "gt-xs" | "gt-sm" | "gt-md";

export const FX_MEDIA_QUERIES: Record<FxBreakpoint, string> = {
  xs: "(max-width: 599.98px)",
  sm: "(min-width: 600px) and (max-width: 959.98px)",
  md: "(min-width: 960px) and (max-width: 1279.98px)",
  "gt-xs": "(min-width: 600px)",
  "gt-sm": "(min-width: 960px)",
  "gt-md": "(min-width: 1280px)"
};

export const FX_BREAKPOINT_PRIORITY: FxBreakpoint[] = ["xs", "sm", "md", "gt-xs", "gt-sm", "gt-md"];

export function toBoolean(value: unknown, defaultValue = true): boolean {
  if (value === null || value === undefined || value === "") return defaultValue;
  if (typeof value === "boolean") return value;
  const normalized = String(value).trim().toLowerCase();
  return !(normalized === "false" || normalized === "0" || normalized === "off" || normalized === "no");
}

export function pickResponsiveValue<T>(baseValue: T | undefined, overrides: Partial<Record<FxBreakpoint, T | undefined>>, isActive: (breakpoint: FxBreakpoint) => boolean): T | undefined {
  let selected = baseValue;
  for (const breakpoint of FX_BREAKPOINT_PRIORITY) {
    const override = overrides[breakpoint];
    if (override !== undefined && isActive(breakpoint)) selected = override;
  }
  return selected;
}
